import { render, staticRenderFns } from "./CardKey.vue?vue&type=template&id=7970a686&scoped=true"
import script from "./CardKey.vue?vue&type=script&lang=js"
export * from "./CardKey.vue?vue&type=script&lang=js"
import style0 from "./CardKey.vue?vue&type=style&index=0&id=7970a686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7970a686",
  null
  
)

export default component.exports